/**! Qoopido.demand 5.1.0-rc.4 | https://github.com/dlueth/qoopido.demand | (c) 2018 Dirk Lueth */
(function () {
	"use strict";

	function definition(functionIterate, cacheStates) {
		function compareAccess(a, b) {
			if (a.accessed < b.accessed) return -1;
			if (a.accessed > b.accessed) return 1;
			else return 0
		}
		return function (size) {
			var item, states = cacheStates();
			states.sort(compareAccess);
			while (size > 0 && states.length) {
				size -= (item = states.shift())
					.size;
				demand.cache.clear(item.id)
			}
		}
	}
	provide(["/demand/function/iterate", "./states"], definition)
})();
